import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'services/localization';
import { PaymentMethodHeaderRow } from '../../../components/PaymentMethodHeaderRow';
import { PaymentMethodRow } from '../../../components/PaymentMethodRow';

interface Props {
	chargesEnabled: boolean;
}

export const StripePaymentMethods = ({ chargesEnabled }: Props) => {
	const { t } = useTranslation();
	return (
		<>
			<PaymentMethodHeaderRow />
			<Box py={2}>
				<PaymentMethodRow
					name="CARD_ONLINE_STRIPE"
					disabled={!chargesEnabled}
					helperText={
						!chargesEnabled
							? t(
									'account.payments.stripePaymentsDisabled',
									'Payments are disabled for this Stripe account',
							  )
							: undefined
					}
					pricingDescription={t('account.payments.exclStripeFees', 'Excl. Stripe fees')}
				/>
			</Box>
		</>
	);
};
